import { FormAppearance } from '@/features/MarketoForm/MarketoForm.interface';
import { makeStyles } from '@material-ui/core/styles';
import { colorMap } from '@/utils/constants';
import { getOr } from 'lodash/fp';

const JustificationMap = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

const useMarketoFormAppearanceStyles = makeStyles(
  (muiTheme) => ({
    formButtonAlign: (props: Partial<FormAppearance>) => {
      if (props.buttonAlignment === 'fullWidth') {
        return {
          '& .MuiButtonBase-root.button[type=submit]': {
            width: '100%',
          },
        };
      }
      return {
        '& .MuiGrid-item:is(:has(.MuiButtonBase-root.button[type=submit]))': {
          display: 'flex',
          justifyContent: JustificationMap[props.buttonAlignment || 'left'],
        },
      };
    },
    formBackground: (props: Partial<FormAppearance>) => ({
      backgroundColor: `${getOr('', props.backgroundColor || '', colorMap)} !important`,
      borderRadius: '5px',
    }),
    formShadow: {
      boxShadow: muiTheme.shadows[8],
    },
    formContained: {
      padding: muiTheme.spacing(4, 3),
    },
  }),
  { name: 'useMarketoFormAppearance' },
);

export const useMarketoFormAppearance = (appearanceConfig: Partial<FormAppearance> = {}) => {
  const classes = useMarketoFormAppearanceStyles(appearanceConfig);

  return [
    appearanceConfig?.buttonAlignment && classes.formButtonAlign,
    appearanceConfig?.backgroundColor && classes.formBackground,
    appearanceConfig?.dropShadow && classes.formShadow,
    appearanceConfig?.contained && classes.formContained,
  ].filter(Boolean);
};
